export enum LineStatus {
  blck = 'BLCK',
  ended = 'END',
  rel = 'REL',
}
